var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeaderBottomDesktop = function SvgHeaderBottomDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 11,
    fill: "none",
    preserveAspectRatio: "none",
    viewBox: "0 0 1920 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1920 11V3.79s-332.47 6.592-470.15 7.21zm-503.85 0c-53.54-.324-115.91-2.304-182.68-4.423C1148.11 3.867 1055.54.93 965.007.93c-85.157 0-180.594 2.844-274.715 5.65C633.146 8.281 576.485 9.97 522.903 11zM314.043 11H0V3.79S165.747 8.812 314.043 11",
    clipRule: "evenodd"
  })));
};
export default SvgHeaderBottomDesktop;